import {useEffect, useRef, useState} from "react";
import { getCountries, isPossiblePhoneNumber } from "react-phone-number-input";
import { PrimaryButton } from "../Buttons";
import { CheckboxInput, PasswordInput, SelectInput, TelephoneInput, TextInput } from "../Inputs";
import {useAdminRegistrationStepStore, useLoaderStore, useRegistrationStore} from "../../context";
import { useAlert, useApi } from "../../hooks";
import { formatCurrency, isValidEmail, isValidPassword } from "../../utils/helpers";
import {getTimezonesForCountry} from "countries-and-timezones";
import {Tooltip} from "react-tooltip";
import {InfoSlideOver} from "../Menus";
import constants from "../../utils/constants";
import { Link, useNavigate } from "react-router-dom";

export default function TermsAndPolicyRegistrationForm({handleSubmitCallback}){
    const { setRegistrationUser, registrationUser} =
    useRegistrationStore();
    const alert = useAlert();
    const [acceptedTermAndConditions, setAcceptedTermAndConditions] = useState(registrationUser?.acceptedTermAndConditions ?? false);
    const [acceptedPrivacyPolicy, setAcceptedPrivacyPolicy] = useState(registrationUser?.privacyPolicyAccepted ?? false);

    const isValid = () => {
        if (!acceptedTermAndConditions) {
          alert("Invalid input", "Terms and conditions must be accepted before registering", "warning");
          return false;
        }    
        if (!acceptedPrivacyPolicy) {
          alert("Invalid input", "Privacy policy must be accepted before registering", "warning");
          return false;
        }
        return true;
    };

    async function handleSubmit() {
        if (!isValid()) return;
        let userInfo = {
            ...registrationUser,
            acceptedTermAndConditions,
            acceptedPrivacyPolicy
        };
        setRegistrationUser(userInfo)
        handleSubmitCallback(userInfo);
    }

    return (
      <div className="w-10/12 md:w-9/12 space-y-4">
        {console.log("acceptedTermAndConditions", acceptedTermAndConditions)}
        {console.log("acceptedPrivacyPolicy", acceptedPrivacyPolicy)}
        <div className="text-primaryColor text-lg font-semibold flex flex-row justify-start border-b">
          Terms and Policy
        </div>
        <div className="flex flex-col justify-between mt-4">
            <CheckboxInput
                textSize="text-sm"
                label={
                    <div>
                        I accept {constants.APP_NAME}'s &nbsp;
                        <span className="text-primary cursor-pointer underline">
                            <Link
                                to="/termsAndConditions"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Terms & Conditions
                            </Link>
                        </span>
                    </div>
                }
                name="t&c"
                value={acceptedTermAndConditions ? "checked" : "unchecked"}
                onChange={() =>
                    setAcceptedTermAndConditions(!acceptedTermAndConditions)
                }
            />
            <CheckboxInput
                textSize="text-sm"
                label={
                    <div>
                        I accept {constants.APP_NAME}'s &nbsp;
                        <span className="text-primary cursor-pointer underline">
                            <Link
                                to="/privacyPolicy"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Privacy Policy
                            </Link>
                        </span>
                    </div>
                }
                name="privacy"
                value={acceptedPrivacyPolicy ? "checked" : "unchecked"}
                onChange={() =>
                    setAcceptedPrivacyPolicy(!acceptedPrivacyPolicy)
                }
            />
        </div>
        <PrimaryButton
          text="SUBMIT"
          disabled={!acceptedTermAndConditions || !acceptedPrivacyPolicy}
          onClick={handleSubmit}
        />
      </div>
    );
}